import { toFixedNum } from 'helpers/number'
import { logger } from 'utils/logger'

const batteryStatus = async () => {
    try {
        const battery = await navigator.getBattery()
        const updateChargingInfo = () =>
            logger.debug(
                '[battery] charging time: ' + battery.chargingTime + ' seconds'
            )
        const updateChargeInfo = () =>
            logger.debug(
                '[battery] charging: ' + (battery.charging ? 'Yes' : 'No')
            )

        const updateLevelInfo = () =>
            logger.debug(
                '[battery] level: ' + toFixedNum(battery.level * 100) + '%'
            )

        updateChargeInfo()
        updateLevelInfo()
        updateChargingInfo()

        battery.addEventListener('chargingchange', updateChargeInfo)
        battery.addEventListener('levelchange', updateLevelInfo)
        battery.addEventListener('chargingtimechange', updateChargingInfo)
    } catch (e) {
        logger.error('battery api not supported')
    }
}

export default batteryStatus
